<div class="bg-danger text-white d-flex align-items-center rounded-pill font-size-12 p-2 expired-pill">
  {{ 'fgbcl.wallet.expired' | translate: { fgbdefault: 'EXPIRED' } }}:
  {{ ExpirationDate | UtcToLocaltimePipe: dateOption.ShortDateFormat }}
</div>
